module.exports = __webpack_public_path__ + "static/media/6f9.fe0d1010.jpg";